export default {
  apiKey: '',
  style: 'mapbox://styles/advisr/cka5nbx9r19l41is10i0o3vne'
}
